var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoLink = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 .117a7.884 7.884 0 1 0 0 15.768A7.885 7.885 0 1 0 8 .116zm0 1a6.885 6.885 0 1 1 0 13.77 6.885 6.885 0 0 1 0-13.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.385 6.27c.575 0 1.048.434 1.108.993l.007.122v4.307a.5.5 0 0 1-.992.09l-.008-.09V7.385a.116.116 0 0 0-.079-.11l-.036-.006H6.154a.5.5 0 0 1-.09-.992l.09-.008h1.23zm-.308-3.078.101.007a.809.809 0 0 1-.101 1.609.808.808 0 0 1-.101-1.609l.1-.007z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.846 11.194a.5.5 0 0 1 .09.991l-.09.009H6.154a.5.5 0 0 1-.09-.992l.09-.008h3.692z"
}))));
export { SvgInfoLink as ReactComponent };
export default __webpack_public_path__ + "assets/images/info-link.svg";